export default "__VITE_ASSET__664711f8__"